import axios from "axios";
import { createUrl } from "./createUrl";

export default class FnrFetch4 {
  constructor(url, postData, mockData) {
    this.cancelSource = axios.CancelToken.source();

    if (url) this.url = url;
    if (postData) this.postData = postData;
    if (mockData) this.mockData = mockData;
  }

  post() {
    return new Promise((fnrFetchResolve, fnrFetchReject) => {
      axios
        .post(createUrl(this.url), this.postData, {
          withCredentials: true,
          cancelToken: this.cancelSource.token,
        })
        .then((response) => {
          // resolve with mockData if it exists
          if (this.mockData) {
            const saw = String.fromCodePoint(0x1fa9a);

            console.log(
              `%c${saw} using mockData: ${this.url}`,
              "color: #278DC1; font-weight: bold; font-size: 12px;"
            );
            
            if (this.mockData.success) fnrFetchResolve(this.mockData);
            if (!this.mockData.success) fnrFetchReject(this.mockData);
            return;
          }

          if (response.data.success) fnrFetchResolve(response.data);
          fnrFetchReject(response.data);
        })
        .catch((error) => {
          if (!axios.isCancel(error)) fnrFetchReject(error);
        });
    });
  }

  cancel() {
    this.cancelSource.cancel();
  }
}
